import { combineEpics, withState } from "redux-most";
import { allPass, chain, filter, flip, map, pipe } from "ramda";
import { of } from "most";
import { recoverWith } from "common/mostCurried";
import * as steps from "common/steps";
import * as uploadActions from "./uploadActions";
import * as applicationActions from "application/applicationActions";
import * as submissionActions from "submission/submissionActions";
import {
  isStepActive,
  isStepCompleted,
  isSubmissionTypesEmpty,
  getWorkFiles,
} from "common/selectors";
import {
  createSyncLocalStorageEpic,
  createLoadLocalStorageEpic,
  createCompleteStepEpic,
  createAcknowledgeSubmissionEpic,
} from "common/stepEpicCommon";
import { fetchSubmissionTypes } from "common/stipAjax";

const isStepInitAction = action =>
  action.type === submissionActions.LOCAL_STORAGE_LOADED ||
  action.type === submissionActions.SET_ACTIVE_STEP;

const loadSubmissionTypesFilter = ([state, action]) =>
  isStepInitAction(action) &&
  allPass([isStepActive(steps.FILE_UPLOAD), isSubmissionTypesEmpty])(state);

export const loadSubmissionTypesEpic = pipe(
  flip(withState),
  filter(loadSubmissionTypesFilter),
  chain(
    pipe(
      fetchSubmissionTypes,
      map(uploadActions.submissionTypesLoaded),
      recoverWith(pipe(applicationActions.appError, of))
    )
  )
);

const syncLocalStorageEpic = createSyncLocalStorageEpic(
  [
    submissionActions.ADD_ANOTHER_WORK,
    submissionActions.CANCEL_SUBMISSION,
    submissionActions.SUBMIT,
    submissionActions.SET_SUBMISSION_FILES,
    submissionActions.UPDATE_SUBMISSION_FILES,
    uploadActions.COMPLETE_STEP,
    uploadActions.SET_WORK_FILES,
    uploadActions.UPDATE_WORK_FILES,
  ],
  {
    completed: isStepCompleted(steps.FILE_UPLOAD),
    workFiles: getWorkFiles,
  },
  uploadActions.localStorageSynced,
  steps.FILE_UPLOAD
);

export default combineEpics([
  createAcknowledgeSubmissionEpic(steps.FILE_UPLOAD),
  createCompleteStepEpic(uploadActions.COMPLETE_STEP, steps.FILE_UPLOAD),
  createLoadLocalStorageEpic(
    steps.FILE_UPLOAD,
    uploadActions.localStorageLoaded
  ),
  loadSubmissionTypesEpic,
  syncLocalStorageEpic,
]);
